import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
  Outlet,
} from 'react-router-dom';
import { StakePage } from 'src/pages/stake/Stake.page';
import { DefiPage } from 'src/pages/defi/Defi.page';
import { NotFoundPage } from 'src/pages/not-found/NotFound.page';
import { SwapPage } from 'src/pages/swap/Swap.page';
import { AprPointsPage } from 'src/pages/AprPoints/AprPoints.page';
import { Layout } from 'src/components/Layout/Layout';
import { SHOW_SWAPR_PAGE, SHOW_DEFI_PAGE } from 'src/constants';
import { useTokensInfo } from 'src/api/dex';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <Layout>
          <Outlet />
        </Layout>
      }
    >
      <Route path="/" element={<StakePage />} />
      {SHOW_SWAPR_PAGE && <Route path="/swapr" element={<SwapPage />} />}
      {SHOW_DEFI_PAGE && <Route path="/ecosystem" element={<DefiPage />} />}
      <Route path="/aprboost" element={<AprPointsPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Route>
  )
);

export function Router() {
  const {} = useTokensInfo();
  return <RouterProvider router={router} />;
}
